import React, { Component } from "react";

import "./error-boundary.css";
import { logErrorApi } from "../../../api/publicApi";

class CustomErrorBoundaryClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
    this.timeoutId = null;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Capture URL details
    const urlDetails = {
      href: window.location.href,
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
    };

    // Serialize error details
    const errorDetails = {
      urlDetails, // include URL details
      timestamp: new Date().toISOString(),
      error: { message: error.message, stack: error.stack },
      errorInfo: { componentStack: errorInfo.componentStack },
    };

    logErrorApi({ errorDetails }).catch((error) => {
      console.error("Error logging failed:", error);
    });

    console.error("Error caught in ErrorBoundary:", error, errorInfo);

    // Redirect to home page after 3 seconds
    this.timeoutId = setTimeout(() => {
      this.setState({ hasError: false });
      window.location.replace("/");
    }, 3000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.hasError && !this.state.hasError) {
      clearTimeout(this.timeoutId);
    }
  }

  componentWillUnmount() {
    // Clear the timeout to prevent memory leaks
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-message-container">
          <h1 className="error-message-title">Something went wrong</h1>
          <div className="error-message-subtitle">Redirecting to home page</div>
        </div>
      );
    }

    return this.props.children;
  }
}

const CustomErrorBoundary = (props) => {
  return <CustomErrorBoundaryClass {...props} />;
};

export default CustomErrorBoundary;
